import React from 'react';
import { createRoot } from 'react-dom/client';
import DynamicBanner from './dynamic-banner';

export default (element, data) => {
  const root = createRoot(element);
  root.render(<DynamicBanner {...data} />);
};
